export const keysKz = {
  list: [
    {
      type: '1',
      line: [
        {
          letter: 'й',
        },
        {
          letter: 'ц',
        },
        {
          letter: 'у',
        },
        {
          letter: 'к',
        },
        {
          letter: 'е',
        },
        {
          letter: 'н',
        },
        {
          letter: 'г',
        },
        {
          letter: 'ш',
        },
        {
          letter: 'щ',
        },
        {
          letter: 'з',
        },
        {
          letter: 'х',
        },
      ],
    },
    {
      type: '1',
      line: [
        {
          letter: 'ф',
        },
        {
          letter: 'ы',
        },
        {
          letter: 'в',
        },
        {
          letter: 'а',
        },
        {
          letter: 'п',
        },
        {
          letter: 'р',
        },
        {
          letter: 'о',
        },
        {
          letter: 'л',
        },
        {
          letter: 'д',
        },
        {
          letter: 'ж',
        },
        {
          letter: 'э',
        },
      ],
    },
    {
      type: '1',
      line: [
        {
          letter: 'ъ',
        },
        {
          letter: 'я',
        },
        {
          letter: 'ч',
        },
        {
          letter: 'с',
        },
        {
          letter: 'м',
        },
        {
          letter: 'и',
        },
        {
          letter: 'т',
        },
        {
          letter: 'ь',
        },
        {
          letter: 'б',
        },
        {
          letter: 'ю',
        },
      ],
    },
    {
      type: 'last',
      line: [
        {
          letter: 'ұ',
        },
        {
          letter: 'ү',
        },
        {
          letter: 'қ',
        },
        {
          letter: 'ғ',
        },
        {
          letter: 'ң',
        },
        {
          letter: 'һ',
        },
        {
          letter: 'і',
        },
        {
          letter: 'ә',
        },
        {
          letter: 'ө',
        },
        {
          letter: 'bksp',
          className: 'keyboard__button_bksp',
          type: 'bksp',
        },
      ],
    },
  ],
};
